class CustomFooter extends HTMLElement {
    connectedCallback() {
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: block;
                    background-color: #0f172a;
                    color: white;
                    padding: 3rem 1rem;
                }
                .footer-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 2rem;
                }
                .footer-logo {
                    height: 50px;
                    margin-bottom: 1rem;
                }
                .footer-heading {
                    font-family: 'Playfair Display', serif;
                    font-size: 1.25rem;
                    margin-bottom: 1rem;
                    color: #f8e8e8;
                }
                .footer-links {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }
                .footer-link {
                    color: #cbd5e1;
                    text-decoration: none;
                    transition: color 0.3s;
                }
                .footer-link:hover {
                    color: white;
                }
                .contact-info {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }
                .contact-item {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    color: #cbd5e1;
                }
                .social-links {
                    display: flex;
                    gap: 1rem;
                    margin-top: 1rem;
                }
                .social-link {
                    color: white;
                    transition: color 0.3s;
                }
                .social-link:hover {
                    color: #f8e8e8;
                }
                .copyright {
                    text-align: center;
                    margin-top: 3rem;
                    padding-top: 1rem;
                    border-top: 1px solid #1e293b;
                    color: #94a3b8;
                }
            </style>
            <div class="footer-container">
                <div>
                    <img src="https://huggingface.co/spaces/TheWizard42/cleanspot-jordan-station-sparkle/resolve/main/images/opulence%20logo%20with%20Text%201.png" alt="Opulence One Logo" class="footer-logo">
<p class="mt-2">Concierge-level cleaning for homes, estates, and businesses.</p>
                <div class="mt-4">
                    <p class="text-sm text-gray-400">Proudly serving the Niagara Region.</p>
</div>
</div>
                <div>
                    <h3 class="footer-heading">Company</h3>
                    <div class="footer-links">
                        <a href="about.html" class="footer-link">About Us</a>
                        <a href="how-it-works.html" class="footer-link">How It Works</a>
                        <a href="services.html" class="footer-link">Our Services</a>
                    <a href="/#booking-form" class="footer-link">Request Quote</a>
</div>
                </div>
<div>
                    <h3 class="footer-heading">Contact</h3>
                    <div class="contact-info">
                        <div class="contact-item">
                            <i data-feather="phone"></i>
                            <span>(289) 990-6319</span>
</div>
                        <div class="contact-item">
                            <i data-feather="mail"></i>
                            <span>opulenceone23@gmail.com</span>
</div>
                        <div class="contact-item">
                            <i data-feather="clock"></i>
                    <span>Mon-Fri: 8am-6pm</span>
</div>
                    </div>
                    <div class="social-links">
                        <a href="https://facebook.com/opulenceone" class="social-link" target="_blank" rel="noopener noreferrer"><i data-feather="facebook"></i></a>
                        <a href="https://instagram.com/opulenceone" class="social-link" target="_blank" rel="noopener noreferrer"><i data-feather="instagram"></i></a>
                        <a href="https://linkedin.com/company/opulenceone" class="social-link" target="_blank" rel="noopener noreferrer"><i data-feather="linkedin"></i></a>
</div>
                </div>
            </div>
            <div class="copyright">
                &copy; ${new Date().getFullYear()} Opulence One. All rights reserved.
            </div>
        `;
    }
}
customElements.define('custom-footer', CustomFooter);